import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Settings, Copy, Coffee } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Settings className="w-8 h-8 text-cyan-400" data-id="element-71" />,
    title: 'Configura',
    desc: 'Aplica las "Instrucciones Maestras" para que la IA entienda quién eres y qué haces.'
  }, {
    icon: <Copy className="w-8 h-8 text-cyan-400" data-id="element-72" />,
    title: 'Copia y Pega',
    desc: 'Usa los bloques de contexto para tus tareas del día (correos, reportes, minutas).'
  }, {
    icon: <Coffee className="w-8 h-8 text-cyan-400" data-id="element-73" />,
    title: 'Libera tu tiempo',
    desc: 'Entrega resultados perfectos y cierra tu laptop antes que todos los demás.'
  }];
  return <section className="py-24 bg-[#0d1322] relative overflow-hidden" data-id="element-74">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-75">
        <FadeIn data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-16" data-id="element-77">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-78">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-cyan-500/0 via-cyan-500/30 to-cyan-500/0" data-id="element-79" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative" data-id="element-80">
              <div className="bg-[#111827] border border-slate-800 rounded-2xl p-8 text-center h-full hover:border-cyan-500/30 transition-colors relative z-10" data-id="element-81">
                <div className="w-20 h-20 mx-auto bg-[#0a0f1a] border border-cyan-500/30 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(6,182,212,0.15)]" data-id="element-82">
                  {step.icon}
                </div>
                <div className="absolute top-4 right-4 text-6xl font-black text-slate-800/30 select-none" data-id="element-83">
                  {index + 1}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-84">
                  {step.title}
                </h3>
                <p className="text-[#d1d5db] text-lg leading-relaxed" data-id="element-85">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}